import { render, staticRenderFns } from "./SectionComponent.vue?vue&type=template&id=dddbe908&scoped=true"
import script from "./SectionComponent.vue?vue&type=script&lang=js"
export * from "./SectionComponent.vue?vue&type=script&lang=js"
import style0 from "./SectionComponent.vue?vue&type=style&index=0&id=dddbe908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddbe908",
  null
  
)

export default component.exports